import {ETrackedItemTypes} from "../../../../constants/trackedItems";

const FAVORITE_TYPE = ETrackedItemTypes.ULTRASONIC_CONFIGURATION
const INNERVTAB_URL_PARAM = 'innervtabs-1'
const FAVORITE_PARAM_ID = INNERVTAB_URL_PARAM
const TRACKED_ITEM_LABEL_PREFIX = "Ultrasonic"

export interface UltrasonicPropertiesTableRow {
  propertyName: string
  propertyValue: string
  unit: string
}
export interface UltrasonicPropertiesObject{
  key: string
  label: string
  unit: string
}

export const UltrasonicPropsKeyToTitleMap: UltrasonicPropertiesObject[] = [

  {
    key: "azimuthFOV",
    label: "Instrumentation Azimuth Limit",
    unit: "deg"
  },
  {
    key: "elevationFOV",
    label: "Instrumentation Elevation Limit",
    unit: "deg"
  },
  {
    key: "maxInstrumentedRange",
    label: "Instrumentation Range Limit",
    unit: "m"
  },
]

export const fovAndBoresightUltrasonicKeyToLabelMap: UltrasonicPropertiesObject[] = [
  {
    key: "azimuth_fov",
    label: "Azimuth FOV",
    unit: "deg"
  },
  {
    key: "elevation_fov",
    label: "Elevation FOV",
    unit: "deg"
  },
  {
    key: "max_range",
    label: "Max Det. Range at Boresight",
    unit: "m"
  }
]

export interface ObjectPropertiesInput{
  key: string
  label: string
  isDropDown?: boolean
  unit: string
}

export interface ObjectPropertyRow{
  objectPropertyName: string
  unit: string
  objectPropertyValue: string
  objectPropertyKey: string
}

export const objectPropertiesInput: ObjectPropertiesInput[] = [
  {
    key: "objectCategory",
    label: "Object Category",
    unit: ""
  },
  {
    key: "objectName",
    label: "Object Name",
    unit: ""
  },
  {
    key: "objectVersion",
    label: "Object Version",
    unit: ""
  },
  {
    key: "objectProperties",
    label: "Object Variants",
    isDropDown: true,
    unit: ""
  },
  {
    key: "temperature",
    label: "Temperature",
    unit: "°C"
  },
  {
    key: "firingMode",
    label: "Firing Mode",
    unit: ""
  },
]
// Column names for the Blueline export
export const COLUMN_NAMES = {
  AZIMUTH_ANGLE: "Azimuth Angle (deg)",
  DISTANCE: "Distance (m)",
}
export {
  FAVORITE_TYPE,
  INNERVTAB_URL_PARAM,
  FAVORITE_PARAM_ID,
  TRACKED_ITEM_LABEL_PREFIX
}